'use client'

import { useTranslations } from 'next-intl'
import { memo } from 'react'

import NoQueryResult from 'component/block/no-content/query-result'
import ScrollLoad from 'component/block/scrollLoad'
import { useInitialMediaStore } from 'store/global/media'
import useSearchResultComments from '../use-search-result-comments'
import SearchResultThumbnail from 'component/page/media/small-media/search-result-thumbnail'
import { formatMediaAsset, formatMediaThumbnailType } from 'util/comment'
import { normalizeAsset } from 'util/normalizeAsset'
import GridLoading from 'component/block/loading/grid-loading'

interface ISpotResult {
  queryKeywords: string
}
const MediaResult = ({ queryKeywords }: ISpotResult) => {
  const t = useTranslations()
  const setInitComment = useInitialMediaStore(state => state.setInitComment)

  const { comments, noMoreData, fetchNextPage, isFetching } =
    useSearchResultComments(queryKeywords)

  if (isFetching && comments.length === 0) {
    return <GridLoading />
  }

  if (comments.length === 0) {
    return (
      <NoQueryResult className='m-auto max-w-[432px] py-[32px] text-center'>
        {t('search.no_result.keyword', {
          search_term: queryKeywords
        })}
      </NoQueryResult>
    )
  }

  return (
    <>
      <div className='grid grid-cols-3 gap-[1px] mb-[1px]'>
        {comments.map((comment, index) => {
          const gtm = index % 16 === 0 || index % 16 === 7
          const { comment: main } = comment
          const media = main.media?.[0]
          const asset = formatMediaAsset(media)
          return (
            <SearchResultThumbnail
              key={main.id}
              asset={asset}
              keyword={queryKeywords}
              isGtm={gtm}
              desc={main.text || ''}
              onClick={() => {
                setInitComment(main)
              }}
            />
          )
        })}
      </div>
      <ScrollLoad
        callback={fetchNextPage}
        fetching={isFetching}
        fetchEnd={noMoreData}
      />
    </>
  )
}

export default memo(MediaResult)
